import { useCallback } from 'react';

import { useDeviceType } from '@braskai/ui-kit';

import { useBalanceStore } from '@/entities/balance';
import { useOnboardingStore } from '@/entities/user/currentUser';

import { OnboardingStepKeys } from '@/shared/types/Onboarding';

export const useOnboardingEvent = (step: OnboardingStepKeys, isAvailableForAllPlans = false) => {
  const shouldRender = useOnboardingStore((state) => state.stepStatuses[step]);
  const setNextStep = useOnboardingStore((state) => state.setNextStep);
  const { hasTrialPlan } = useBalanceStore();

  const { isMobile } = useDeviceType();

  const canShow = shouldRender && (hasTrialPlan || isAvailableForAllPlans) && !isMobile;

  return useCallback(() => {
    if (canShow) {
      setNextStep(step);
    }
  }, [canShow, setNextStep, step]);
};
